module.exports = __webpack_public_path__ + "static/media/hourglass_blue_full8dc0e34f6f579e84239e3e46a343a0a6.webp";